"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChatbotStreamInput = instanceOfChatbotStreamInput;
exports.ChatbotStreamInputFromJSON = ChatbotStreamInputFromJSON;
exports.ChatbotStreamInputFromJSONTyped = ChatbotStreamInputFromJSONTyped;
exports.ChatbotStreamInputToJSON = ChatbotStreamInputToJSON;
var ChatbotStreamItem_1 = require("./ChatbotStreamItem");
/**
 * Check if a given object implements the ChatbotStreamInput interface.
 */
function instanceOfChatbotStreamInput(value) {
    if (!('content' in value) || value['content'] === undefined)
        return false;
    if (!('history' in value) || value['history'] === undefined)
        return false;
    return true;
}
function ChatbotStreamInputFromJSON(json) {
    return ChatbotStreamInputFromJSONTyped(json, false);
}
function ChatbotStreamInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'],
        'history': (json['history'].map(ChatbotStreamItem_1.ChatbotStreamItemFromJSON)),
    };
}
function ChatbotStreamInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
        'history': (value['history'].map(ChatbotStreamItem_1.ChatbotStreamItemToJSON)),
    };
}
